import { createWrapper } from '../../fhir-react/base';

export const AppointmentWrapper = createWrapper('Appointment', () => ({}));
export type WrappedAppointment = ReturnType<typeof AppointmentWrapper>;